import { ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { AppIcons } from '../../../shared/app.icons';
import { AppSettings } from '../../../shared/app.settings';
import { MITableComponent } from '../../../shared/components/mi-table/mi-table.component';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../shared/services/entity.service';
import { ListResponse } from '../../../shared/models/listResponse.models';
import { Router } from '@angular/router';
import { MetaDataService } from '../../../shared/services/meta-data.service';
import { RestApiService } from '../../../shared/services/rest-api.service';
import { ConfigService } from '../../../shared/services/config.service';
import { LoaderService } from '../../../shared/components/loader/loader.service';
import { MenuItem } from 'primeng/api';
import { EntityCountsResponse, EntityList } from '../../../shared/models/entity.models';
import { Country } from '../../../shared/models/country';
import { Language } from '../../../shared/models/language';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { TranslateModule } from '@ngx-translate/core';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-order-history',
  standalone: true,
  imports: [BreadcrumbModule,
    ButtonModule,
    TabViewModule, TranslateModule, MITableComponent, MITableComponent, ToastModule],
  templateUrl: './order-history.component.html',
  styleUrl: './order-history.component.scss'
})
export class OrderHistoryComponent implements OnInit, OnChanges {
  @ViewChild('uploader', { static: true }) uploader: ElementRef<HTMLElement>;
  @ViewChild(MITableComponent) tableRef: MITableComponent;
  @Input() siteId: string;
  @Input() protocolId: string;
  miIcons = AppIcons;
  activeIndex: number = 0;
  isLoading = true;
  filterAvailableColumns = [];
  cols = [];
  moduleName = 'order';
  filterList;
  btnLabel: string;
  isShowMenu: boolean = true;
  attributeLabels = {};
  filterAttributeLabels = {};
  listColumns: any;
  allColumns: any;
  pagination: any;
  totalRecords: number = 0;
  tableData: any = [];
  buttons: any[] = [];
  country: Country;
  language: Language;
  entityCount: EntityCountsResponse;
  itemsPerPage: number;
  entityData: EntityList = {
    limit: AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT,
    offset: 0,
    searchStr: "",
    filters: [],
    advanceFilters: [],
    countryCode: '',
    deleted: AppSettings.DELETED_TYPE.ONLY_NON_DELETED,
    forTenantCode: this.configService.getForTenantCode(),
    actionStatus: ""
  };
  routePath: MenuItem[] = [];
  deleteOrderMsg: string;
  deleteOrderHeaderMsg: string;
  showMenu: boolean = false;
  moduleHeaderSecondaryBtnMenuItems: MenuItem[] = [];
  filterFieldsArray: any[];
  isReady: boolean = false;
  attributeData: any;
  data;
  rowItems: MenuItem[] | undefined;
  rowItemsCompleted: MenuItem[] | undefined;
  bulkSelectionsItems: MenuItem[] | undefined;
  currentRow;
  visiblePrintLabel: boolean = false;
  showBulkUpdateDialog: boolean = false;
  visible: boolean = false;
  bulkUpdateHeader;
  reviewHeader: any;
  btnUpdate: any;
  entityCreatedAtAttributeId;
  regionGeofences: any = [];
  zoneIds: any = [];
  isEntity = true;
  orderStatusAttributeId: string;
  showImportExportBtn: boolean = false;
  selectedOrder: any;

  isListAllAllowed: boolean = false;
  isListActiveAllowed: boolean = false;
  isListToBeInvoicedAllowed: boolean = false;
  isListDeletedAllowed: boolean = false;
  isListCompletedAllowed: boolean = false;
  isListRejectedAllowed: boolean = false;
  isAddOrderAllowed: boolean = false;
  userDetailsById: any[] = [];
  btnDownloadInvoice: string;
  usersData: any[] = [];
  siteAttributeId: string;

  constructor(private orderService: EntityService,
    private cs: CommonBindingDataService,
    private router: Router,
    private metaDataService: MetaDataService,
    private restApiService: RestApiService,
    private configService: ConfigService, private loaderService: LoaderService,
    private cdr: ChangeDetectorRef

  ) { }

  ngOnInit() {
    this.initializeLabels();
    this.initializeOtherVariablesAndAPI();
    this.getMetaData();
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.siteId) {
      this.isLoading = true;
      this.tableData = [];
      this.totalRecords = 0;
      this.siteAttributeId = null;

      if (this.siteId || this.protocolId) {
        this.initializeLabels();
        this.initializeOtherVariablesAndAPI();
        this.getMetaData();
        this.cdr.detectChanges();
      }
    }
  }


  getMetaData() {
    const payload = this.getMultiApiPayload();
    this.metaDataService.metaDataMultipleApi(payload).subscribe({
      next: (res) => {
        try {
          const advancedFilter = JSON.parse(res.advancedFilter.responseBody);
          if (advancedFilter) {
            this.setOrderFilterView(advancedFilter);
          }

          const sort = JSON.parse(res.sort.responseBody);
          const entityCreatedAt = sort.tabs[0].groups[0].fields.find(field => field.attributeCode === AppSettings.ENTITY_CREATED_AT);
          this.entityCreatedAtAttributeId = entityCreatedAt?.attributeId;
          if (this.entityCreatedAtAttributeId) {
            this.entityData.defaultSortType = AppSettings.DESC_SORT_ORDER;
          }

          const defaultTableView = JSON.parse(res.defaultTableView.responseBody);
          if (defaultTableView) {
            this.setOrderTableView(defaultTableView);
          }
          this.cs.applyFilterToColumn(defaultTableView, sort);

          if (this.siteId) {
            this.searchEntity();
          } else {
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private getMultiApiPayload() {
    return [
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.ORDER}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.ADVANCED_FILTER,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.ORDER}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=${AppSettings.VIEW_CODE.DEFAULT_SORT_VIEW}`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.SORT,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
      {
        url: `${AppSettings.BASE_URL}${this.configService.getLoggedInTenantCode()}/api/v1/entity-conf/${AppSettings.ENTITY_CODE.ORDER}/attributes?forTenantCode=${this.configService.getForTenantCode()}&viewCode=DASHBOARD_ORDER_HISTORY_VIEW`,
        inputBody: '',
        method: 'GET',
        outputKey: AppSettings.META_OUTPUT_KEY.DEFAULT_TABLE_VIEW,
        headers: this.restApiService.getHeaderForMultipleAPI()
      },
    ]
  }


  private initializeLabels() {
    this.entityData.forTenantCode = this.configService.getForTenantCode();
    this.bulkUpdateHeader = this.cs.getLabel('lbl_update_orders');
    this.reviewHeader = this.cs.getLabel('lbl_review_orders');
    this.btnUpdate = this.cs.getLabel('btn_update_orders2');
    this.routePath = [{ label: this.cs.getLabel('order.lbl_orders'), routerLink: 'orders/list' }];
    this.btnDownloadInvoice = this.activeIndex === 2 ? this.cs.getLabel('order.mark_as_completed_and_download_invoice') : this.cs.getLabel('order.download_invoice');
  }

  private initializeOtherVariablesAndAPI() {
    this.btnLabel = this.cs.getLabel('order.add_order');
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
    this.deleteOrderMsg = this.cs.getLabel('order.message.confirm_delete_msg');
    this.deleteOrderHeaderMsg = this.cs.getLabel('order.message.confirm_delete_header');
    this.itemsPerPage = AppSettings.PAGINATION_ROWS_PER_PAGE_LIMIT;
  }


  getTableView() {
    this.orderService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW, false).subscribe(res => {
      if (res) {
        this.setOrderTableView(res);
      }
    });
  }

  setOrderTableView(res) {
    this.data = res;
    this.orderStatusAttributeId = res.tabs[0].groups[0].fields.find(field => field.attributeCode === 'order_status')?.attributeId;

    this.attributeLabels = this.cs.getAttributeLabels(this.data);

    this.allColumns = this.cs.getColumns(this.data).filter(column =>
      !['entity_created_at'].includes(column.attributeCode)
    );

    this.allColumns?.forEach((key, index) => {
      this.allColumns[index] = key;
      this.allColumns[index].field = key.attributeCode;
      if (this.configService.isSiteUser()) {
        if (key.attributeCode === 'total_units') {
          this.allColumns[index].header = this.cs.getLabel('order.qty_ordered')
        } else if (key.attributeCode === 'created_by') {
          this.allColumns[index].header = this.cs.getLabel('order.ordered_by')
        } else {
          this.allColumns[index].header = this.cs.getLabelValue(
            `order` + `.fields.${key.attributeCode}.label`,
            this.attributeLabels,
            key.attributeCode
          );
        }
      } else {
        if (key.attributeCode === 'expected_delivery_date') {
          this.allColumns[index].header = this.cs.getLabel('order.lbl_delivery_date');
        } else {
          this.allColumns[index].header = this.cs.getLabelValue(
            `order` + `.fields.${key.attributeCode}.label`,
            this.attributeLabels,
            key.attributeCode
          );
        }
      }

    });
    this.filterAvailableColumns = _.clone(this.allColumns);

    if (this.siteId) {
      this.searchEntity();
    } else {
      this.isLoading = false;
      this.cdr.detectChanges();
    }
  }

  getFilterView() {
    this.orderService.getAttributeDefinition(AppSettings.ENTITY_CODE.ORDER, AppSettings.VIEW_CODE.ADVANCED_FILTER_VIEW).subscribe(filterResponse => {
      if (filterResponse) {
        this.setOrderFilterView(filterResponse);
      }
    });
  }

  setOrderFilterView(filterResponse) {
    try {
      this.filterAttributeLabels = this.cs.getAttributeLabels(filterResponse);
      this.filterList = this.cs.getColumns(filterResponse);
      this.filterList = _.sortBy(this.filterList, 'attributeIndex');
      this.filterList.filter((field: { attributeCode: string;[key: string]: unknown }) => {

        if (field.attributeCode === 'protocol_id') {
          field.moduleName = AppSettings.ENTITY_CODE.PROTOCOL;
          return true;
        }

        if (field.attributeCode === 'entity_created_at') {
          field.inputCode = 'dateRange';
          return true;
        }
      });

      this.siteAttributeId = this.filterList.find(field => field.attributeCode == 'site_id')?.attributeId;
    } catch (error) {
      this.siteAttributeId = null;
    }
  }

  onSortData(sortColumnDetails) {
    this.entityData.defaultSortColumn = sortColumnDetails.attributeId;
    this.entityData.defaultSortType = (sortColumnDetails.sortOrder === 1) ? AppSettings.ASC_SORT_ORDER : AppSettings.DESC_SORT_ORDER;
    this.searchEntity();
  }

  searchEntity() {

    if (!this.siteAttributeId) {
      this.isLoading = false;
      this.cdr.detectChanges();
      return;
    }

    const tableView = this.configService.isSiteUser() ? AppSettings.VIEW_CODE.ORDER_LIST_ON_SITE_ADMIN : AppSettings.VIEW_CODE.DEFAULT_TABLE_VIEW;

    this.entityData.filters = [];
    if (this.siteId && this.siteId !== 'all') {
      this.entityData.filters.push({
        attributeId: this.siteAttributeId,
        attributeValue: this.siteId
      });
    }
    // Add protocol filter if protocolId is provided
    const protocolField = this.filterList?.find(field => field.attributeCode === 'protocol_id');
    if (this.protocolId && protocolField) {
      this.entityData.filters.push({
        attributeId: protocolField.attributeId,
        attributeValue: this.protocolId
      });
    }

    const statusAttributeId = this.orderStatusAttributeId || this.filterList?.find(field => field.attributeCode === 'order_status')?.attributeId;
    if (statusAttributeId) {
      this.entityData.filters.push({
        attributeId: statusAttributeId,
        attributeValue: ['ORDER_COMPLETED']
      });
    }

    this.entityData.countryCode = AppSettings.HEADER_COUNTRY_CODE;
    this.entityData.tableViewCode = tableView;
    this.loaderService.show();
    this.isLoading = true;

    this.orderService.searchEntity(AppSettings.ENTITY_CODE.ORDER, this.entityData, false).subscribe({
      next: (res: ListResponse) => {
        try {
          this.listColumns = res?.data[0]?.values;
          this.pagination = res?.pagination;
          this.totalRecords = res?.count || 0;
          this.loaderService.hide();
          const rawData = res.data.map((data: any) => {
            const flatRelatedValues = (data.relatedData || []).reduce((acc: any, item: any) => {
              if (item.entityCode !== 'order') {
                return {
                  ...acc,
                  ...(item.values || {})
                };
              }
              return acc;
            }, {});

            const orderData = (data.relatedData || []).filter(item => item.entityCode === 'order')
              .map(item => ({
                id: item.id,
                ...(item.values || {})
              }));
            return {
              id: data.id,
              actionStatus: data.actionStatus,
              ...(data.values || {}),
              ...flatRelatedValues,
              order: orderData
            };
          });
          this.tableData = rawData;
          this.cdr.detectChanges();
          this.loaderService.hide();
          this.isLoading = false;
        } catch {
          this.loaderService.hide();
        }
      },
      error: () => {
        this.loaderService.hide();
      }
    });
  }

  onAddOrder() {
    this.router.navigate(['app/orders/add-order',]);
  }

  onPageChange(event) {
    this.entityData.offset = event?.first;
    this.entityData.limit = event?.rows;
    this.searchEntity();
    this.isLoading = false;
    this.loaderService.hide();
  }

  itemPerPageChange(event) {
    this.itemsPerPage = event;
    this.entityData.limit = this.itemsPerPage;
    this.searchEntity();
    this.isLoading = false;
    this.loaderService.hide();
  }

  isReadyToDisplay(): boolean {
    return !this.isLoading && this.allColumns && this.allColumns.length > 0;
  }

  onRowSelect(event) {
    if (event.type === 'row') {
      const queryParams: any = {
        id: event.data.id,
        fromDashboard: 'true'
      };

      // Pass protocol and site IDs to preserve filter state
      if (this.protocolId) {
        queryParams.protocolId = this.protocolId;
      }
      if (this.siteId && this.siteId !== 'all') {
        queryParams.siteId = this.siteId;
      }

      this.router.navigate(['app/orders/order-details'], {
        queryParams
      });
      this.orderService.entityCurrentRow.next(event.data);
    }
  }
}






